import {DelayedAjaxPost} from "../../common/ajax";

export function EntListingActionServerSelectionMgr(
    chkTable,
    chkAllElm,
    nSelected,
    nSelectable,
    ajaxManager,
    csrfToken
) {
    this.chkTable = chkTable;
    this.chkAllElm = chkAllElm;
    this.nSelectable = nSelectable;
    this.nSelected = nSelected;
    this.ajaxManager = ajaxManager;
    this.csrfToken = csrfToken;

    this.allWasToggled = false;

    this.postMgr = new DelayedAjaxPost(
        new String(document.location),
        this,
        250,
        ajaxManager
    );

    this.rowToggled = function (rowChk) {
        if (rowChk.getChecked()) this.nSelected++;
        else this.nSelected--;

        this.postMgr.dataReady();
    };

    this.allToggled = function () {
        this.allWasToggled = true;
        if (this.chkAllElm.checked) this.nSelected = this.nSelectable;
        else this.nSelected = 0;

        this.postMgr.dataReady();
    };

    this.buildPOSTBody = function () {
        let params = ["_select"];

        // was the 'all' checkbox toggled?
        if (this.allWasToggled) {
            this.allWasToggled = false;
            if (this.chkAllElm.checked) params.push("ALL");
            else params.push("NONE");
        } else {
            params.push("UPDATE");
            params.push("addIds");
            params.push(this.chkTable.getCheckedIDs());
            params.push("remIds");
            params.push(this.chkTable.getUncheckedIDs());
        }

        params.push("_CSRFToken");
        params.push(this.csrfToken);

        // we don't want this post to invalidate the referer (in webActionServlet)
        params.push("no_record_post");
        params.push("");

        return params;
    };
}
